import cn from 'classnames'
import { SlugInput } from '@components/SlugInput'
import { SlugInputFieldProps } from './interface'

export function SlugInputField({
  className,
  label,
  classNameInput,
  classNameLabel,
  error,
  rightIcon,
  leftIcon,
  ...props
}: SlugInputFieldProps) {
  return (
    <div className={className}>
      {label && (
        <div
          className={cn(
            'text-[12px] font-light mb-[6px] text-black-480',
            classNameLabel
          )}
        >
          {label}
        </div>
      )}

      <div className='relative'>
        {leftIcon && (
          <div className='absolute top-1/2 left-0 transform -translate-y-1/2 ml-[20px]'>
            {leftIcon}
          </div>
        )}
        <SlugInput
          className={cn('border-gray', classNameInput, {
            'border-red': error,
            'pr-[80px]': rightIcon,
            'pl-[50px]': leftIcon,
          })}
          {...props}
        />
        {rightIcon && (
          <div className='absolute right-0 top-1/2 transform -translate-y-1/2 mr-[20px] text-[14px] text-black-970'>
            {rightIcon}
          </div>
        )}
      </div>
    </div>
  )
}
